import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectorRef,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Language } from '../../../models/language';
import { LanguageService } from '../../../services/language.service';
// import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
// import { SourceActions } from '../../shared/source_actions/source_actions.component';
// import { SubmissionPreviewComponent } from '../../shared/submission-preview/submission-preview.component';
import { ReportService } from "../../../services/report.service";
import { ActivatedRoute } from "@angular/router";
// import { SpinnerService } from '../../../services/spinner.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { map, switchMap, takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { SourcePreviewComponent } from 'src/app/sharedModule/report/sourcePreview/source-preview/source-preview.component';


@Component({
  selector: 'app-language-bar',
  templateUrl: './language-bar.component.html',
  styleUrls: ['./language-bar.component.scss'],
  providers: [MatProgressBarModule]
})
export class LanguageBar implements OnInit, OnChanges, OnDestroy {
  title = 'Language Bar';
  visibleSourcesCount: number = 4;
  @Input() isOnAnalysis!: boolean;
  @Input() similarityAnalysis: any;
  @Input() canEdit: boolean;
  @Input() allSources: any;
  languages: Language[] = [];
  document_languages: any[] = [];
  isMenuOpen: boolean = false;
  isSummaryMenuOpen: boolean = false;
  // ref: DynamicDialogRef | undefined;
  submissionId: string = ''
  selectedLanguageType: string = 'Original'
  selectedFilterText: string = 'Matching sources'
  selectedSources: number[] = []
  percentageWithQuotes = true
  showTopSources: number | null = null
  transLangs = [];
  currentTranslateLanguage: string = '';
  currentLanguage: string = '';
  isDocumentTranslated: boolean = false;
  topTranslatedSources: any[] = [];
  topOriginalSources: any[] = [];
  initialSources: any[] = [];
  filteredOriginalSources: any[] = [];
  filteredTranslatedSources: any[] = [];
  filteredSources: any[] = [];
  selectedLanguageCode;

  private destroy$ = new Subject<void>();
  originalPercentage: number;
  overallTransltedPercentage: number;
  originalPercentageWithoutQuotes: number
  overallTransltedPercentageWithoutQuotes: number;
  show
  topTranslatedSourcesLength: number = 0
  originalityDisplay: string = '';
  highRiskThreshold: number = 80;
  mediumRiskThreshold: number = 70;
  @ViewChild('heading') heading: ElementRef;

  // Add this property to the class
  private handleGlobalClickBound: (event: Event) => void;

  constructor(
    private reportService: ReportService,
    private languageService: LanguageService,
    // private dialogService: DialogService,
    // private spinnerService: SpinnerService,
    private acRouter: ActivatedRoute,
    private toastr: ToastrService,
    private spinnerService: NgxSpinnerService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const settings = user?.Institution?.InstitutionSettings?.[0];

    this.originalityDisplay = settings?.originalityDisplay || 'percentage';
    this.highRiskThreshold = settings?.originalityRiskFactorHighRisk || 80;
    this.mediumRiskThreshold = settings?.originalityRiskFactorMediumRisk || 70;

    this.reportService.sourcesObject.subscribe((data) => {
      this.allSources.sources = data.sources
    })
    this.reportService.currentTranslatedLanguageObject.subscribe((data) => {
      this.currentTranslateLanguage = data;
    })

    this.reportService.documentPercentagesObject.subscribe((percentages: { originalPercentage: number, overallTransltedPercentage: number, originalPercentageWithoutQuotes: number, overallTransltedPercentageWithoutQuotes: number }) => {
      this.originalPercentage = percentages.originalPercentage
      this.overallTransltedPercentage = percentages.overallTransltedPercentage

      this.originalPercentageWithoutQuotes = percentages.originalPercentageWithoutQuotes
      this.overallTransltedPercentageWithoutQuotes = percentages.overallTransltedPercentageWithoutQuotes
    })

    this.reportService.selectedTransltaionCodeObject.subscribe((data) => {
      if (data !== null) {
        this.selectedLanguageCode = data
      }
    })

    this.reportService.toggleQuotesObject.subscribe((data: boolean) => {
      this.percentageWithQuotes = data
    })

    this.acRouter.params.subscribe((data: any) => {
      if (data.id) {
        this.submissionId = data.id;
      } else {
        this.submissionId = data.submissionId;
      }
    })

    if (this.languages.length == 0) {
      this.languageService.getLanguages().subscribe((languages) => {
        this.languages = languages;
        this.updateDocumentLanguages()
      });
    } else {
      this.updateDocumentLanguages();
    }

    // Store the event handler as a property to be able to remove it later
    this.handleGlobalClickBound = (event) => this.handleGlobalClick(event);
    document.addEventListener('click', this.handleGlobalClickBound);

    this.reportService.selectLanguageObject.subscribe((data) => {

      this.selectedLanguageType = data.type
      this.currentLanguage = data.language
      this.languageService.getLanguageCode(this.currentLanguage).subscribe((data) => {
        if (data !== null && data.length !== 0) {
          this.reportService.selectedTransltaionCodeSubject.next(data)
        }
      })
      let language = data

      if (this.document_languages.length > 0) {
        if (this.document_languages.length <= 2) {
          if (language.type == 'Original') {
            this.toggleSources(this.document_languages[0]);
          } else {
            this.toggleSources(this.document_languages[1]);
          }
        } else {
          if (language.language == 'multiple_languages') {
            // Get the  translated  language with the highest percentage
            let highestLang = this.document_languages[1];
            // Toggle that language
            this.toggleSources(highestLang);
          } else {
            for (let i = 0; i < this.document_languages.length; i++) {
              const lang = this.document_languages[i];
              if (lang.type == data.type && !lang.isOpen && !lang.sourcesClosed) {
                this.toggleSources(lang);
                break;
              }
              else {
                if (language.type == 'Original') {
                  this.toggleSources(this.document_languages[0]);
                }
              }
            }
          }

        }
      }
    })

    this.reportService.initialSourcesObject.subscribe((data) => {
      if (data) {
        // Use pre-calculated top sources from ReportComponent
        this.topOriginalSources = data.topOriginalSources || [];
        this.topTranslatedSources = data.topTranslatedSources || [];

        // Initialize both filtered arrays
        this.filteredOriginalSources = [...this.topOriginalSources];
        this.filteredTranslatedSources = [...this.topTranslatedSources];

        // Set the topTranslatedSourcesLength based on the actual filtered sources
        this.topTranslatedSourcesLength = this.filteredTranslatedSources.length;

        // Set filteredSources based on the current language type
        this.filteredSources = this.selectedLanguageType === 'Original' ?
          this.filteredOriginalSources : this.filteredTranslatedSources;

        // Make sure excludedSources is properly set from excludedSourcesMlPlag
        if (!this.allSources.excludedSources && data.excludedSourcesMlPlag) {
          this.allSources.excludedSources = data.excludedSourcesMlPlag;
        }

        // Initialize currentTranslateLanguage if we have translated languages
        if (this.document_languages && this.document_languages.length > 1) {
          this.currentTranslateLanguage = this.document_languages[1]?.language || '';
        }
      }
    })

    this.reportService.selectAnalysisTypeSubject.subscribe((analysisType) => {
      if (analysisType == 'none') {
        this.closeAllTopSources()
      }
    })

    // Subscribe to expanded language state changes
    this.reportService.expandedLanguageObject
      .pipe(takeUntil(this.destroy$))
      .subscribe((expandedLanguage) => {
        if (expandedLanguage && expandedLanguage.code && expandedLanguage.type && this.document_languages.length > 0) {
          // Only process the expanded state if it matches the currently selected language type
          if (this.selectedLanguageType === expandedLanguage.type) {
            // Find the language in document_languages
            const index = this.document_languages.findIndex(lang =>
              lang.languageCode === expandedLanguage.code && lang.type === expandedLanguage.type
            );

            if (index !== -1) {
              // Restore the expanded state without changing the language selection
              this.showTopSources = index;
              // Make sure this language is marked as open
              this.document_languages[index].isOpen = true;
              this.document_languages[index].sourcesClosed = false;

              // Close other languages
              this.document_languages.forEach((lang, i) => {
                if (i !== index) {
                  lang.sourcesClosed = true;
                  lang.isOpen = false;
                }
              });

              // Update filtered sources based on the selected language type
              this.updateFilteredSourcesByLanguageType(expandedLanguage.type);

              // Force a UI update
              this.cdr.detectChanges();
            }
          }
        }
      });

    // Update filtered sources when filter or language changes
    this.reportService.filterSourcesObject.pipe(
      switchMap(param => this.reportService.selectLanguageObject.pipe(
        map(lang => ({ param, lang }))
      ))
    ).subscribe(({ param, lang }) => {
      // For excluded sources (param === 3), use the excluded sources directly
      if (param === 3) {
        // For original language
        if (this.selectedLanguageType === 'Original') {
          let excludedOriginal = [];

          // Try different ways to access original excluded sources
          if (this.allSources.excludedSources?.original) {
            // If excludedSources has an 'original' property
            excludedOriginal = this.allSources.excludedSources.original;
          } else if (Array.isArray(this.allSources.excludedSources)) {
            // If excludedSources is an array, look for an item with language='original'
            const originalItem = this.allSources.excludedSources.find(item =>
              item.language === 'original' || item.language === undefined
            );

            if (originalItem) {
              excludedOriginal = originalItem.sources || [];
            } else {
              // If no specific original language item found, try to use the first item
              // or any item that doesn't have a specific language
              const firstItem = this.allSources.excludedSources[0];
              if (firstItem && (!firstItem.language || firstItem.language === 'original')) {
                excludedOriginal = firstItem.sources || [];
              }
            }
          } else if (typeof this.allSources.excludedSources === 'object') {
            // If excludedSources is an object but doesn't have an 'original' property,
            // try to use it directly if it has a 'sources' property
            excludedOriginal = this.allSources.excludedSources.sources || [];
          }

          // If we still don't have any excluded sources, use the entire excludedSources as a fallback
          if (excludedOriginal.length === 0 && this.allSources.excludedSources) {
            if (Array.isArray(this.allSources.excludedSources)) {
              excludedOriginal = this.allSources.excludedSources;
            } else {
              excludedOriginal = [this.allSources.excludedSources];
            }
          }

          // Make sure to set isExcluded flag for proper display
          excludedOriginal.forEach(source => {
            source.isExcluded = true;
          });

          this.filteredOriginalSources = excludedOriginal;

        }
        // For translated language - keep existing code
        else if (this.selectedLanguageType === 'Translated') {
          let excludedTranslated = [];

          // Check if we have excludedSourcesMlPlag
          if (Array.isArray(this.allSources.excludedSources)) {

            // Find sources for the current language
            const excludedForLanguage = this.allSources.excludedSources.find(
              (item: any) => item.language === this.currentTranslateLanguage
            );

            if (excludedForLanguage && excludedForLanguage.sources) {
              excludedTranslated = excludedForLanguage.sources;
            } else {
              // If no sources found for the specific language, collect all excluded sources
              excludedTranslated = [];
              this.allSources.excludedSources.forEach((langItem: any) => {
                if (langItem.sources && Array.isArray(langItem.sources)) {
                  const sourcesWithLang = langItem.sources.map((source: any) => ({
                    ...source,
                    languageCode: langItem.language,
                    isExcluded: true
                  }));
                  excludedTranslated = [...excludedTranslated, ...sourcesWithLang];
                }
              });
            }
          } else if (this.allSources.excludedSources?.translations) {
            // Handle case where excludedSources has a translations property
            const translations = this.allSources.excludedSources.translations;

            if (Array.isArray(translations)) {
              // If translations is an array of language objects
              const excludedForLanguage = translations.find(
                (item: any) => item.language === this.currentTranslateLanguage
              );
              excludedTranslated = excludedForLanguage?.sources || [];
            } else if (typeof translations === 'object') {
              // If translations is an object with language keys
              excludedTranslated = translations[this.currentTranslateLanguage] || [];
            }
          } else {
            // Fallback to whatever is in excludedSources
            excludedTranslated = this.allSources.excludedSources || [];
          }

          // Make sure to set isExcluded flag for proper display
          excludedTranslated.forEach(source => {
            source.isExcluded = true;
          });

          this.filteredTranslatedSources = excludedTranslated;
        }
        return;
      }

      // For other filter types, filter the pre-calculated top sources
      if (lang.type === 'Original') {
        this.filteredOriginalSources = this.filterTopSources(this.topOriginalSources, param);
      } else if (lang.type === 'Translated') {
        this.filteredTranslatedSources = this.filterTopSources(this.topTranslatedSources, param);
      }
    });
  }

  handleGlobalClick(event: Event): void {
    // Check if the clicked element is inside the menubar or the button that opens the menubar
    const isMenubarElement = (event.target as HTMLElement).closest('.sources_menu') !== null;
    const isMenuBarButton = (event.target as HTMLElement).closest('.sources_menu_btn') !== null;

    // If the clicked element is outside the menubar and buttons, close both menus
    if (!isMenubarElement && !isMenuBarButton) {
      this.closeMenu();
    }
  }

  selectSourceToHighlight(sourceNo: number) {
    const index = this.selectedSources.indexOf(sourceNo);
    index === -1 ? this.selectedSources.push(sourceNo) : this.selectedSources.splice(index, 1);
    this.reportService.selectedSourcesSubject.next(this.selectedSources);
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes['similarityAnalysis'] &&
      changes['similarityAnalysis'].currentValue
    ) {
      let translatedLangs;
      if (this.similarityAnalysis) {
        if (this.similarityAnalysis.submission?.translatedLanguage && this.similarityAnalysis.submission?.translatedLanguage.split('').includes('[')) {
          translatedLangs = JSON.parse(this.similarityAnalysis.submission.translatedLanguage);
        } else {
          translatedLangs = [this.similarityAnalysis.submission?.translatedLanguage];
        }
      }

      this.isDocumentTranslated = translatedLangs.length > 0;


      this.updateDocumentLanguages();

      // Get top translated sources
      if (this.similarityAnalysis.translatedSources) {
        if (this.initialSources.length == 0) {
          this.initialSources = this.similarityAnalysis.translatedSources;
        }
      }
      // Get top original sources
      this.reportService.selectLanguageObject.subscribe((data) => {
        this.filterSources(0, data.type)
      })
    }
  }

  getTopTranslatedSources(translatedSources: any[], topN: number = 5): any[] {
    // Flatten all sources from all languages and include the language code
    let allSources: any[] = [];

    translatedSources?.forEach((lang: any) => {
      if (Array.isArray(lang)) {
        (lang as any).sources.forEach((source: any) => {
          allSources.push({
            ...source,
            languageCode: (lang as any).language
          });
        });
      } else {
        if (lang.sources && Array.isArray(lang.sources)) {
          lang.sources.forEach((source: any) => {
            allSources.push({
              ...source,
              languageCode: lang.language
            });
          });
        } else {
          allSources.push(lang);
        }
      }
    });

    // Sort sources by percentage and take the top N
    allSources.sort((a, b) => b.percentage - a.percentage);
    return allSources.slice(0, topN);
  }

  getTopOriginalSources(originalSources: any[], topN: number = 5): any[] {
    let allSources: any[] = [];
    originalSources?.forEach((source: any) => {
      if (!source.hide) {
        allSources.push(source);
      }
    });

    // // Sort sources by percentage and take the top N
    allSources.sort((a, b) => b.percentage - a.percentage);
    return allSources.slice(0, topN);
  }


  startDocumentPreview(id: string, languageCode: string,index): void {
    this.spinnerService.show()
    this.reportService
      .submissionPreview(
        id,
        this.submissionId,
        index
      )
      .pipe()
      .subscribe(
        (data) => {
          this.spinnerService.hide()
          this.dialog.open(SourcePreviewComponent, {
            data,

            panelClass: 'custom-dialog-container'
          });
        },
        (error) => {
          this.spinnerService.hide()
        }
      );
  }

  getPercentage(lang: any): number {
    return lang.type === 'Original'
      ? (this.percentageWithQuotes ? lang.percentage : lang.percentageWithoutQuotes)
      : (this.percentageWithQuotes
        ? this.similarityAnalysis.submission.translatedPercentage
        : this.similarityAnalysis.submission.translatedPercentageWithoutQuotes);
  }

  getRiskLabel(lang: any): string {
    const value = this.getPercentage(lang);
    if (value >= this.highRiskThreshold) return 'High Risk';
    if (value >= this.mediumRiskThreshold) return 'Medium Risk';
    return 'Low Risk';
  }


  updateDocumentLanguages() {
    // Update document_languages based on similarityAnalysis
    const tempLanguages = [...this.document_languages]
    this.document_languages = [];
    const addLanguage = (type: string, languageCode: string, sourcesClosed: boolean) => {
      const language = languageCode ? this.getLanguageName(languageCode) : null;
      let percentage = this.similarityAnalysis.submission?.[`${type.toLowerCase()}Percentage`];
      let percentageWithoutQuotes = this.similarityAnalysis.submission?.[`${type.toLowerCase()}PercentageWithoutQuotes`];

      if (type == 'Translated' && this.similarityAnalysis.submission.translatedPercentages != null) {
        percentage = this.similarityAnalysis?.submission?.translatedPercentages?.[languageCode]?.percentage || 0;
        percentageWithoutQuotes = this.similarityAnalysis?.submission?.translatedPercentages?.[languageCode]?.percentageWithoutQuotes || 0;
      }

      const totalSources = this.similarityAnalysis?.[`${type.toLowerCase()}Sources`];
      const hideLoadMoreButton = !language || !totalSources || totalSources.length <= this.visibleSourcesCount;

      if (language) {
        this.document_languages.push({
          type,
          language,
          languageCode,
          percentage: percentage || 0,
          percentageWithoutQuotes,
          sourcesClosed: type === 'Translated',
          visibleSourcesCount: this.visibleSourcesCount,
          hideLoadMoreButton,
          totalSources,
          isOpen: false
        });
      }
    };

    addLanguage('Original', this.similarityAnalysis?.submission?.originalLanguage, false);
    if (this.similarityAnalysis?.submission?.translatedLanguage) {
      let translatedLanguages;

      if (this.similarityAnalysis?.submission?.translatedLanguage.split('').includes('[')) {
        translatedLanguages = JSON.parse(this.similarityAnalysis?.submission?.translatedLanguage);
      } else {
        translatedLanguages = [this.similarityAnalysis?.submission?.translatedLanguage];
      }

      translatedLanguages.forEach((lang: string) => {
        const language = this.getLanguageName(lang);
        if (language !== 'Unknown Language' && !this.transLangs.includes(language)) {
          this.transLangs.push(language);
        }

        addLanguage('Translated', lang, true);
      });
    }

    let originalLanguages = this.document_languages.filter(lang => lang.type === 'Original');
    let translatedLanguages = this.document_languages
      .filter(lang => lang.type === 'Translated')
      .sort((a, b) => b.percentage - a.percentage);

    // Retain the isOpen and sourcesClosed values from tempLanguages
    tempLanguages.forEach((tempLang) => {
      let matchingLang;
      if (tempLang.type === 'Original') {
        matchingLang = originalLanguages.find(lang => lang.languageCode === tempLang.languageCode);
      } else if (tempLang.type === 'Translated') {
        matchingLang = translatedLanguages.find(lang => lang.languageCode === tempLang.languageCode);
      }

      if (matchingLang) {
        matchingLang.isOpen = tempLang.isOpen;
        matchingLang.sourcesClosed = tempLang.sourcesClosed;
      }
    });

    // Combine updated original and translated languages into document_languages
    this.document_languages = [...originalLanguages, ...translatedLanguages];

    // Ensure that changes are reflected in the template
    this.cdr.detectChanges();

  }

  public getLanguageName(languageCode: string): string {
    const language = this.languages.find((lang) => lang.value === languageCode);
    return language ? language.text : 'Unknown Language';
  }

  toggleSources(language: any, event?: Event) {
    if (this.currentLanguage == 'multiple_languages') {
      this.languageService.getLanguageName(language.languageCode).subscribe((data) => {
        this.currentLanguage = data
        language.language = data
      });
    }

    if (event) {
      event.stopPropagation();
    }

    if (language.languageCode) {
      this.reportService.selectedTransltaionCodeSubject.next(language.languageCode)
    }

    language.isOpen = true;
    language.sourcesClosed = false;

    // First update the language type and emit the language change
    if (this.currentLanguage != language.language || this.selectedLanguageType !== language.type) {
      this.currentLanguage = language.language;
      this.selectedLanguageType = language.type;

      // Emit language change first
      this.reportService.selectLanguageSubject.next({
        language: language.language,
        type: language.type
      });

    }

    if (language.type === 'Translated') {
      this.reportService.currentTranslatedLanguageSubject.next(language.languageCode);
    }

    this.selectedSources = [];
    this.document_languages.forEach((lang) => {
      if (lang.languageCode !== language.languageCode) {
        lang.sourcesClosed = true;
        lang.isOpen = false;
      }
    });

    this.selectedFilterText = 'Matching sources';
    this.cdr.detectChanges();
  }

  toggleOffAllSources() {
    this.document_languages.forEach((lang) => {
      lang.sourcesClosed = true;
      lang.isOpen = false;
    });
  }

  loadMoreSources(language: any): void {
    const totalSources = this.similarityAnalysis[`${language.type.toLowerCase()}Sources`];
    if (language.visibleSourcesCount > totalSources.length) {
      language.hideLoadMoreButton = true;
      this.shouldShowLoadMoreButton(language);
    } else {
      language.visibleSourcesCount += 4;
    }
  }

  shouldShowLoadMoreButton(language: any): boolean {
    return !language.hideLoadMoreButton;
  }

  closeMenu() {
    this.isMenuOpen = false;
    this.isSummaryMenuOpen = false;
  }

  toggleMenu(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isMenuOpen = !this.isMenuOpen;
    // Close the summary menu when opening the main menu
    if (this.isMenuOpen) {
      this.isSummaryMenuOpen = false;
    }
  }

  toggleSummaryMenu(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isSummaryMenuOpen = !this.isSummaryMenuOpen;
    // Close the main menu when opening the summary menu
    if (this.isSummaryMenuOpen) {
      this.isMenuOpen = false;
    }
  }


  filterSources(param: number, languageType?: string, event?: Event): void {
    this.selectedSources = [];
    this.reportService.selectedSourcesSubject.next(this.selectedSources);
    // Stop event propagation if event is provided
    if (event) {
      event.stopPropagation();
    }

    // Call the report service's filter method
    this.reportService.filterSources(param);
    this.reportService.filterSourcesSubject.next(param);

    // Set the selected language type if provided
    if (languageType) {
      this.selectedLanguageType = languageType;
    }

    // Update filter text based on param
    switch (param) {
      case 0:
        this.selectedFilterText = 'Matching sources';
        break;
      case 1:
        this.selectedFilterText = 'Document sources';
        break;
      case 2:
        this.selectedFilterText = 'Internet sources';
        break;
      case 3:
        this.selectedFilterText = 'Removed sources';
        break;
      case 4:
        this.selectedFilterText = 'Sources below 1%';
        break;
    }

    // Close the menu
    this.isMenuOpen = false;
    this.isSummaryMenuOpen = false;

    // Special handling for excluded sources (param === 3)
    if (param === 3) {

      // For original language
      if (this.selectedLanguageType === 'Original') {
        let excludedOriginal = [];

        // Try different ways to access original excluded sources
        if (this.allSources.excludedSources?.original) {
          // If excludedSources has an 'original' property
          excludedOriginal = this.allSources.excludedSources.original;
        } else if (Array.isArray(this.allSources.excludedSources)) {
          // If excludedSources is an array, look for an item with language='original'
          const originalItem = this.allSources.excludedSources.find(item =>
            item.language === 'original' || item.language === undefined
          );

          if (originalItem) {
            excludedOriginal = originalItem.sources || [];
          } else {
            // If no specific original language item found, try to use the first item
            // or any item that doesn't have a specific language
            const firstItem = this.allSources.excludedSources[0];
            if (firstItem && (!firstItem.language || firstItem.language === 'original')) {
              excludedOriginal = firstItem.sources || [];
            }
          }
        } else if (typeof this.allSources.excludedSources === 'object') {
          // If excludedSources is an object but doesn't have an 'original' property,
          // try to use it directly if it has a 'sources' property
          excludedOriginal = this.allSources.excludedSources.sources || [];
        }

        // If we still don't have any excluded sources, use the entire excludedSources as a fallback
        if (excludedOriginal.length === 0 && this.allSources.excludedSources) {
          if (Array.isArray(this.allSources.excludedSources)) {
            excludedOriginal = this.allSources.excludedSources;
          } else {
            excludedOriginal = [this.allSources.excludedSources];
          }
        }

        // Make sure to set isExcluded flag for proper display
        excludedOriginal.forEach(source => {
          source.isExcluded = true;
        });

        this.filteredOriginalSources = excludedOriginal;

        console.log('Original excluded sources after processing:', {
          count: excludedOriginal.length,
          sources: excludedOriginal
        });
      }
      // For translated language - keep existing code
      else if (this.selectedLanguageType === 'Translated') {
        let excludedTranslated = [];

        // Check if we have excludedSourcesMlPlag
        if (Array.isArray(this.allSources.excludedSources)) {

          // Find sources for the current language
          const excludedForLanguage = this.allSources.excludedSources.find(
            (item: any) => item.language === this.currentTranslateLanguage
          );

          if (excludedForLanguage && excludedForLanguage.sources) {
            excludedTranslated = excludedForLanguage.sources;
          } else {
            // If no sources found for the specific language, collect all excluded sources
            excludedTranslated = [];
            this.allSources.excludedSources.forEach((langItem: any) => {
              if (langItem.sources && Array.isArray(langItem.sources)) {
                const sourcesWithLang = langItem.sources.map((source: any) => ({
                  ...source,
                  languageCode: langItem.language,
                  isExcluded: true
                }));
                excludedTranslated = [...excludedTranslated, ...sourcesWithLang];
              }
            });
          }
        } else if (this.allSources.excludedSources?.translations) {
          // Handle case where excludedSources has a translations property
          const translations = this.allSources.excludedSources.translations;

          if (Array.isArray(translations)) {
            // If translations is an array of language objects
            const excludedForLanguage = translations.find(
              (item: any) => item.language === this.currentTranslateLanguage
            );
            excludedTranslated = excludedForLanguage?.sources || [];
          } else if (typeof translations === 'object') {
            // If translations is an object with language keys
            excludedTranslated = translations[this.currentTranslateLanguage] || [];
          }
        } else {
          // Fallback to whatever is in excludedSources
          excludedTranslated = this.allSources.excludedSources || [];
        }

        // Make sure to set isExcluded flag for proper display
        excludedTranslated.forEach(source => {
          source.isExcluded = true;
        });

        this.filteredTranslatedSources = excludedTranslated;
      }

    }
    // Normal filtering for other params
    else {
      // Filter original sources
      this.filteredOriginalSources = this.topOriginalSources.filter(source => {
        // Skip excluded sources for other filters
        if (source.isExcluded) {
          return false;
        }

        // Apply other filters
        switch (param) {
          case 0: // All sources
            return true;
          case 1: // Document sources
            return source.sourceId && !source.sourceUrl;
          case 2: // Internet sources
            return !!source.sourceUrl;
          case 4: // Sources below 1%
            return source.percentage < 1;
          default:
            return true;
        }
      });

      // Filter translated sources
      this.filteredTranslatedSources = this.topTranslatedSources.filter(source => {
        // Skip excluded sources for other filters
        if (source.isExcluded) {
          return false;
        }

        // Apply other filters
        switch (param) {
          case 0: // All sources
            return true;
          case 1: // Document sources
            return source.sourceId && !source.sourceUrl;
          case 2: // Internet sources
            return !!source.sourceUrl;
          case 4: // Sources below 1%
            return source.percentage < 1;
          default:
            return true;
        }
      });

    }

    // Update filteredSources based on the current language type
    this.updateFilteredSourcesByLanguageType(this.selectedLanguageType);

    // Set focus to the heading after filter is applied
    if (this.heading && this.heading.nativeElement) {
      this.heading.nativeElement.focus();
    }
  }

  closeAllTopSources() {
    this.showTopSources = null;
    this.cdr.detectChanges();
  }


  sourceAction(source_no: string,
    source_url: string,
    excludeUrlId: string,
    exclude: boolean,
    excludeUrlPercentage: number,
    language?: string) {
    const action = exclude ? 'Remove' : 'Add'
    const originalLanguage = this.selectedLanguageType === 'Original'
    swal.fire({
      title: exclude ? this.translate.instant('report.remove_source') : this.translate.instant('aria-labels.add_source'),
      text: exclude ? this.translate.instant('report.are_you_sure_you_want_to_exclude_this_source') : this.translate.instant('report.are_you_sure_you_want_to_include_this_source'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#087f23',
      cancelButtonColor: '#c62828',
      cancelButtonText: this.translate.instant('general.cancel'),
      confirmButtonText: exclude ?
        this.translate.instant('aria-labels.remove_source') :
        this.translate.instant('aria-labels.add_source')
    }).then((result) => {

      if (result.isConfirmed) {
        this.spinnerService.show();

        const currentFilterParam = this.getFilterParamFromText(this.selectedFilterText);

        if (action == 'Remove') {
          let languageCode: string;

          if (language && language.length === 2) {
            languageCode = language;
          }
          else if (this.selectedLanguageType === 'Original') {
            languageCode = 'original';
          }
          else {
            if (this.selectedLanguageCode) {
              languageCode = this.selectedLanguageCode;
            }
            else if (this.currentTranslateLanguage && this.currentTranslateLanguage.length === 2) {
              languageCode = this.currentTranslateLanguage;
            }
            else {
              const langToConvert = language || this.currentLanguage || this.currentTranslateLanguage;

              if (langToConvert && langToConvert.length === 2) {
                languageCode = langToConvert;
              } else {
                const foundLanguage = this.languages.find(lang => lang.text === langToConvert);
                languageCode = foundLanguage ? foundLanguage.value : 'original';
              }
            }
          }

          this.reportService.excludeSource(excludeUrlId, this.submissionId, languageCode)
            .subscribe((data: any) => {
              this.selectedSources = [];
              this.reportService.selectedSourcesSubject.next(this.selectedSources);
              this.toastr.success('Successfully removed the source!', 'Source removed', { timeOut: 2000 });
              this.reportService.newS3JsonSubject.next(data[0]);

              // If we're currently viewing removed sources, we should stay on that view
              // Otherwise, go back to matching sources
              const filterToApply = this.selectedFilterText === 'Removed sources' ? 3 : 0;

              // Apply the filter with the current language type
              this.filterSources(filterToApply, originalLanguage ? 'Original' : 'Translated');

              this.spinnerService.hide();
            }, error => {
              console.error('Error excluding source:', error);
              this.toastr.error('Failed to remove the source', 'Error', { timeOut: 2000 });
              this.spinnerService.hide();
            });
        } else {
          let languageCode: string;

          if (language && language.length === 2) {
            languageCode = language;
          }
          else if (this.selectedLanguageType === 'Original') {
            languageCode = 'original';
          }
          else {
            if (this.selectedLanguageCode) {
              languageCode = this.selectedLanguageCode;
            }
            else if (this.currentTranslateLanguage && this.currentTranslateLanguage.length === 2) {
              languageCode = this.currentTranslateLanguage;
            }
            else {
              const langToConvert = language || this.currentLanguage || this.currentTranslateLanguage;

              if (langToConvert && langToConvert.length === 2) {
                languageCode = langToConvert;
              } else {
                const foundLanguage = this.languages.find(lang => lang.text === langToConvert);
                languageCode = foundLanguage ? foundLanguage.value : 'original';
              }
            }
          }

          this.reportService.includeSource(excludeUrlId, this.submissionId, languageCode)
            .subscribe((data: any) => {
              this.selectedSources = [];
              this.reportService.selectedSourcesSubject.next(this.selectedSources);
              this.toastr.success('Successfully added the source!', 'Source added', { timeOut: 2000 });
              this.reportService.newS3JsonSubject.next(data[0]);

              // If we're currently viewing removed sources, we should stay on that view
              // Otherwise, go back to matching sources
              const filterToApply = this.selectedFilterText === 'Removed sources' ? 3 : 0;

              // Apply the filter with the current language type
              this.filterSources(filterToApply, originalLanguage ? 'Original' : 'Translated');

              this.cdr.detectChanges();
              this.spinnerService.hide();
            }, error => {
              console.error('Error including source:', error);
              this.toastr.error('Failed to add the source', 'Error', { timeOut: 2000 });
              this.spinnerService.hide();
            });
        }
      } else if (result.isDenied) {
        swal.fire('Changes are not saved', '', 'info')
      }
    });
  }


  toggleTopSources(index: number, lang: any): void {

    // Toggle showTopSources
    this.showTopSources = this.showTopSources === index ? -1 : index;

    // Send selected language and type to reportService
    this.reportService.selectLanguageSubject.next({
      language: lang.language,
      type: lang.type
    });

    // Save the expanded language state for persistence across component reloads
    if (this.showTopSources !== -1) {
      this.reportService.expandedLanguageSubject.next({
        code: lang.languageCode,
        type: lang.type
      });
    } else {
      this.reportService.expandedLanguageSubject.next({
        code: null,
        type: null
      });
    }

    // Update the selected language type
    this.selectedLanguageType = lang.type;

    // Store the current language for translated sources
    if (lang.type === 'Translated') {
      this.currentTranslateLanguage = lang.language;
    }

    // Apply the current filter to the newly selected language
    // This ensures consistent filtering when switching between languages
    const currentFilterParam = this.getFilterParamFromText(this.selectedFilterText);

    // Apply the filter with the new language type
    this.filterSources(currentFilterParam, lang.type);

    // Close other language sources when a new language is selected
    if (this.showTopSources !== -1) {
      this.document_languages.forEach((language, i) => {
        if (i !== index) {
          language.sourcesClosed = true;
        }
      });
    }
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.handleGlobalClickBound);

    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Safely formats the percentage value, handling null/undefined cases
   * @param percentage The percentage value to format
   * @returns Formatted percentage string
   */
  getSafePercentage(percentage: number | null | undefined): string {
    if (percentage === null || percentage === undefined) {
      return '0';
    }
    return percentage === 0 ? '0' : percentage.toFixed(2);
  }

  /**
   * Filters top sources based on the filter parameter
   * @param sources The sources to filter
   * @param param The filter parameter (0: matching, 1: documents, 2: internet, 4: below 1%)
   * @returns Filtered sources
   */
  private filterTopSources(sources: any[], param: number): any[] {
    if (!sources || !Array.isArray(sources)) {
      return [];
    }

    switch (param) {
      case 0: // Matching sources
        const matchingSources = sources.filter(source => source.percentage > 1 && !source.isExcluded);
        return matchingSources.length > 0 ? matchingSources : sources.filter(source => source.percentage <= 1 && !source.isExcluded);
      case 1: // Sources from documents
      case 2: // Sources from internet
        return sources.filter(source => source.type === param && !source.isExcluded);
      case 4: // Sources below 1%
        return sources.filter(source => source.percentage < 1 && !source.isExcluded);
      default:
        return sources;
    }
  }


  // Add this method to update filtered sources when language type changes
  updateFilteredSourcesByLanguageType(languageType: string): void {
    // Set the selected language type
    this.selectedLanguageType = languageType;

    // Update filteredSources based on language type
    if (languageType === 'Original') {
      this.filteredSources = this.filteredOriginalSources;
    } else if (languageType === 'Translated') {
      this.filteredSources = this.filteredTranslatedSources;

      // Update topTranslatedSourcesLength to match the actual filtered sources length
      this.topTranslatedSourcesLength = this.filteredTranslatedSources.length;
    }
  }

  // Update the openFilterOptions method to call updateFilteredSourcesByLanguageType
  openFilterOptions(languageType: string): void {
    // Update filtered sources based on language type
    this.updateFilteredSourcesByLanguageType(languageType);

    // Open filter options
    this.toggleMenu();
  }

  private getFilterParamFromText(text: string): number {
    switch (text) {
      case 'Matching sources':
        return 0;
      case 'Document sources':
        return 1;
      case 'Internet sources':
        return 2;
      case 'Removed sources':
        return 3;
      case 'Sources below 1%':
        return 4;
      default:
        return 0; // Default to matching sources if no match found
    }
  }
}
